'use client';

import { FC, useState } from 'react';
import { RequestSerivceNotificationProps } from '../types';
import { CatButton } from '@blocks-react/components/Button';
import { CatIconInfo } from '@blocks-react/components/Icons/Info';
import { CatInlineNotification } from '@blocks-react/components/InlineNotification';

export const RequestSerivceNotification: FC<
  RequestSerivceNotificationProps
> = ({ heading, btnLabel }) => {
  const [dismissNotification, setDismissNotification] = useState(false);

  return (
    <CatInlineNotification heading={heading} isDismissed={dismissNotification}>
      <CatIconInfo slot="before" />
      <div slot="after">
        <CatButton variant="ghost" onClick={() => setDismissNotification(true)}>
          {btnLabel}
        </CatButton>
      </div>
    </CatInlineNotification>
  );
};
